export const getLocalStorage = (key) => {
    return JSON.parse(sessionStorage.getItem(key));
    // return sessionStorage.getItem(key);
     //return localStorage.getItem(key);
  }